export enum LearningPathsAllFilterNamesEnum {
  SEARCH_BY_QUERY = 'query',
  PROGRAMS = 'programs',
  PROGRAM_YEARS = 'programYears',
  GRADE_LEVELS = 'gradeLevels',
  PILLARS = 'pillars',
  LANGUAGES = 'languages',
  LEARNING_PATH_STATUSES = 'learningPathStatuses',
}
